<template>
	<div :class="[`home${didSearch ? ' searched' : ''}`]">
		<div class="search-section">
			<!-- <div class="search-other"> -->
			<div class="header5">Welcome to Garbur</div>
			<div class="header1">Are you paying too much in property taxes? Find out now.</div>
			<SearchBar />
			<!-- </div> -->

			<!-- <div class="gradient-back"></div> -->
			<!-- <div class="overlay-image"></div> -->
		</div>

		<div v-if="isLoading" class="spin"></div>
		<Properties v-if="didSearch" :search="searchValue" :addresses="addressResults"></Properties>
	</div>
</template>

<script>
// @ is an alias to /src
import Properties from "@/components/Properites.vue";
import Button from "@/components/ui/Button.vue";
import SearchBar from "@/components/home/SearchBar.vue";
import { mapState } from "vuex";

export default {
	name: "home",
	data() {
		return {
			height: "",
		};
	},
	components: {
		Properties,
		SearchBar,
	},
	computed: {
		...mapState("search", ["addressResults", "searchValue", "didSearch", "isLoading"]),
	},
};
</script>

<style scoped lang="scss">
.home {
	background-color: white;
	margin: 0;
	max-width: unset;
	min-height: unset;
	padding: 0;
	margin-bottom: 100px;

	&.searched {
		.search-section {
			height: 35vh;
		}
	}

	font-size: 14px;
	.search-section {
		padding: 0 5vw;
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: calc(100vh - 105px);
		align-items: center;
		background: linear-gradient(-45deg, rgba(7, 15, 67, 0.8), rgba(67, 29, 129, 0.8), rgba(50, 65, 160, 0.8)),
			url(/img/search-home.png) center center;
		background-size: cover;
		.header5 {
			color: #5edede;
			margin-bottom: 20px;
			font-size: 2em;
		}
		.header1 {
			color: var(--white);
			margin-bottom: 5vh;
			font-size: 51px;
			max-width: 750px;
		}
		@media screen and (max-width: 800px) {
			.header1 {
				font-size: 20px;
			}
		}
	}
}
</style>
